var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rounded-circle bg-transparent text-white mx-2 d-flex justify-content-center alternative border pointer-on-hover align-items-center text-uppercase",class:`border-${_vm.type}`},[_vm._v("\n  "+_vm._s(_vm.answered)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }